import React from 'react';

import {
  Box,
  CreateNoteButton,
  NotesList,
} from '../../../../common/components';

import { Col, Row } from 'react-bootstrap';
import { InternalButtonBar } from '../../../layout/components';
const PolicyNotes = ({ resource, reference }) => {
  const policyNumber = resource?.data.attributes.policy_number;
  const quoteReference = resource?.data.attributes.quote_reference;
  const resourceId = resource?.data.id;



  return (
    <div>
      <Box>
        <h2 className="resource-name">{reference}</h2>
        <NotesList
          resourceId={resourceId}
          autoFilterType={policyNumber ?'filter[resource]' : 'filter[quote_reference]' }
          autoFilterId={policyNumber ?resourceId : quoteReference}
        />

        <Row>
          <Col sm={12}>
            <InternalButtonBar
              buttons={[
                {
                  permissions: ['policy.notes_create'],
                  button: (
                    <CreateNoteButton
                      label="Add a Note"
                      className="pull-right"
                      notableResource={resource}
                      defaultText={
                        policyNumber ? `${policyNumber} | ` : `${quoteReference} | `
                      }
                      notableResourceType={
                        policyNumber ? 'policies' : 'policy-applications'
                      }
                    />
                  ),
                },
              ]}
            />
          </Col>
        </Row>
      </Box>
    </div>
  );
};
export default PolicyNotes;
